import React from "react";
import "assets/stylesheets/TopNav.scss";

const TopNav = () => {
  return (
    <div id="course-compass-banner">
      <a href="https://uac.edu.au" rel="noopener noreferrer" target="_blank">
        <img
          src={"images/uac-logo.svg"}
          alt="Homepage of the Universities Admissions Centre UAC"
        />
      </a>

      <div id="course-compass-banner__return-container">
        <a target="_blank" rel="noopener noreferrer" href="https://uac.edu.au">
          Return to UAC website
        </a>
      </div>
    </div>
  );
};

export default TopNav;
